import { render, staticRenderFns } from "./salesGoods.vue?vue&type=template&id=0a9b7034&scoped=true"
import script from "./salesGoods.vue?vue&type=script&lang=js"
export * from "./salesGoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9b7034",
  null
  
)

export default component.exports